import React from "react";
import cx from "classnames";

export default function FormError({ show, message, noMargin = false }) {
    return <div className={cx(noMargin && "mt-0")}>{show && <div className="alert alert-danger">{message}</div>}</div>;
}
